module.exports = __webpack_public_path__ + "img/antes_despues_332.c459d69a.png";